import { requestToken } from "../api/request_methods";

const API_ROUTE = `${process.env.REACT_APP_NODE_URL}/api/transactions`;

class TransactionHistoryServices {
  async getBalanceLogHistory({ page, limit, q, from, to, userId, paymentType }) {
    try {
      const params = { page, limit, q, from, to, userId, paymentType };
      const action = API_ROUTE + "/balance-log";
      return await requestToken.get(action, params);
    } catch (error) {
      console.error("Error in getBalanceLogHistory:", error);
      throw error;
    }
  }

  async getBalanceLogHistoryForExport({ q, from, to, userId, paymentType }) {
    const limit = 100;
    let page = 1;
    let allData = [];
    let totalPages = 1;
    do {
      const res = await this.getBalanceLogHistory({
        page,
        limit,
        q,
        from,
        to,
        userId,
        paymentType,
      });
      if (!res.isSuccess) throw new Error(res.message || "Failed to fetch");
      allData = allData.concat(res.data || []);
      totalPages = res.pagination?.totalPages || 1;
      page++;
    } while (page <= totalPages);
    return allData;
  }

  async getBalanceHistory({ page, limit, q, from, to, userId, paymentType }) {
    try {
      const params = { page, limit, q, from, to, userId, paymentType };
      const action = API_ROUTE + "/balance-history";
      return await requestToken.get(action, params);
    } catch (error) {
      console.error("Error in getBalanceHistory:", error);
      throw error;
    }
  }

  async getBalanceHistoryForExport({ q, from, to, userId, paymentType }) {
    const limit = 100;
    let page = 1;
    let allData = [];
    let totalPages = 1;
    do {
      const res = await this.getBalanceHistory({
        page,
        limit,
        q,
        from,
        to,
        userId,
        paymentType,
      });
      if (!res.isSuccess) throw new Error(res.message || "Failed to fetch");
      allData = allData.concat(res.data || []);
      totalPages = res.pagination?.totalPages || 1;
      page++;
    } while (page <= totalPages);
    return allData;
  }

  async getBalanceProfileLoss({ page, limit, q, from, to, userId }) {
    try {
      const params = { page, limit, q, from, to, userId };
      const action = API_ROUTE + "/balance-profile-loss";
      return await requestToken.get(action, params);
    } catch (error) {
      console.error("Error in getBalanceProfileLoss:", error);
      throw error;
    }
  }

  async getAllTransactionHistory({ page, limit, q, from, to }) {
    try {
      const params = { page, limit, q, from, to };
      const action = API_ROUTE + "/history";
      return await requestToken.get(action, params);
    } catch (error) {
      console.error("Error in getAllTransactionHistory:", error);
      throw error;
    }
  }

  async getTransactionHistory({ page, limit, q, from, to, userId, gameType }) {
    try {
      const params = { page, limit, q, from, to, userId, gameType };
      const action = API_ROUTE + "/get-transaction-history";
      return await requestToken.get(action, params);
    } catch (error) {
      console.error("Error in getTransactionHistory:", error);
      throw error;
    }
  }

  async getMobileTransactionHistory({
    page,
    limit,
    q,
    from,
    to,
    userId,
    gameType,
  }) {
    try {
      const params = { page, limit, q, from, to, userId, gameType };
      const action = API_ROUTE + "/mobile-transaction-history";
      return await requestToken.get(action, params);
    } catch (error) {
      console.error("Error in getMobileTransactionHistory:", error);
      throw error;
    }
  }

  async getMobileWinDetail(walletTxnId) {
    try {
      const action = API_ROUTE + `/mobile-win-detail/${walletTxnId}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getMobileWinDetail:", error);
      throw error;
    }
  }

  async getTransactionHistoryForExport({ q, from, to, userId, gameType }) {
    const limit = 100;
    let page = 1;
    let allData = [];
    let totalPages = 1;
    do {
      const res = await this.getTransactionHistory({
        page,
        limit,
        q,
        from,
        to,
        userId,
        gameType,
      });
      if (!res.isSuccess) throw new Error(res.message || "Failed to fetch");
      allData = allData.concat(res.data || []);
      totalPages = res.pagination?.totalPages || 1;
      page++;
    } while (page <= totalPages);
    return allData;
  }

  async getTransactionDetails(id) {
    try {
      const action = API_ROUTE + `/details/${id}`;
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getTransactionDetails:", error);
      throw error;
    }
  }


  async getAdminUsers() {
    try {
      const action = API_ROUTE + "/admin-users";
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getAdminUsers:", error);
      throw error;
    }
  }
  
  async getSubAdminUsers() {
    try {
      const action = API_ROUTE + "/sub-admin-users";
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getSubAdminUsers:", error);
      throw error;
    }
  }

  async getOutletUsers() {
    try {
      const action = API_ROUTE + "/outlet-users";
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getOutletUsers:", error);
      throw error;
    }
  }
  async getMobileUsers() {
    try {
      const action = API_ROUTE + "/mobile-users";
      return await requestToken.get(action);
    } catch (error) {
      console.error("Error in getMobileUsers:", error);
      throw error;
    }
  }
}

export default TransactionHistoryServices;

